// extracted by mini-css-extract-plugin
export default {"MainImage":"Home_MainImage__pIVMq","mainImageContainer":"Home_mainImageContainer__KbamC","pastWorkContainer":"Home_pastWorkContainer__tjP+g"};